export default __webpack_public_path__ + "static/media/electronic-img-banner.7adb16b5.png";